export default __webpack_public_path__ + "static/media/exercisesIcon.00829927.png";